// Helper to get the correct image URL
// Handles both old local URLs (/api/uploads/...) and new Cloudinary URLs (https://...)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function getImageUrl(imageUrl) {
  if (!imageUrl) return null;
  
  // If it's already a full URL (Cloudinary), return as-is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    return imageUrl;
  }
  
  // Otherwise, it's a local URL - prepend backend URL
  return `${BACKEND_URL}${imageUrl}`;
}
